import { Navigate, Route, Routes } from "react-router-dom";

import AppHeader from "./components/AppHeader";
import NotAuthorizedPage from "./pages/NotAuthorizedPage";
import NotFoundPage from "./pages/NotFoundPage";
import SessionDetailPage from "./pages/SessionDetailPage";
import SessionsListPage from "./pages/SessionsListPage";

/** The app shell and the route table, on the eval dashboard's page column. */
export default function App() {
  return (
    <div className="min-h-screen">
      <AppHeader />
      <main className="mx-auto max-w-page px-6 pb-12 pt-4">
        <Routes>
          <Route path="/" element={<Navigate to="/sessions" replace />} />
          <Route path="/sessions" element={<SessionsListPage />} />
          <Route path="/sessions/:id" element={<SessionDetailPage />} />
          <Route path="/not-authorized" element={<NotAuthorizedPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </main>
    </div>
  );
}
